import type { JSX } from 'react';

import { ThemeToggle } from './theme-toggle.js';

export interface DocsTopbarProps {
  onMenuToggle?: () => void;
}

/** Fixed top navigation bar for the docs shell. */
export function DocsTopbar({ onMenuToggle }: DocsTopbarProps): JSX.Element {
  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-4 border-b border-[var(--color-docs-border)] bg-[var(--color-docs-surface)] px-4">
      <button
        type="button"
        className="rounded-md p-2 text-sm font-medium lg:hidden"
        onClick={onMenuToggle}
        aria-label="Toggle navigation"
      >
        ☰
      </button>
      <div className="flex items-center gap-2">
        <span className="text-lg font-bold text-[var(--color-docs-accent)]">NRX UI</span>
        <span className="rounded-full bg-[var(--color-docs-accent-soft)] px-2 py-0.5 text-xs font-medium text-[var(--color-docs-accent)]">
          v0.1
        </span>
      </div>
      <div className="ml-auto flex items-center gap-3">
        <div className="hidden flex-1 max-w-sm sm:block">
          <input
            type="search"
            disabled
            placeholder="Search components…"
            aria-label="Search components"
            className="w-full rounded-lg border border-[var(--color-docs-border)] bg-[var(--color-docs-code-bg)] px-3 py-1.5 text-sm text-[var(--color-docs-muted)]"
          />
        </div>
        <ThemeToggle />
      </div>
    </header>
  );
}
